import { useToast } from "@/hooks/use-toast";
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast";

export function Toaster() {
  const { toasts } = useToast();
  // If any toast requests top placement, render viewport at top on mobile
  const mobileTop = toasts.some((t: any) => (t as any).placement === "top");

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, onAction, ...props }) {
        return (
          <Toast key={id} {...props} onAction={onAction}>
            <div className="grid gap-1">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && (
                <ToastDescription>{description}</ToastDescription>
              )}
            </div>
            {action}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport mobilePosition={mobileTop ? "top" : "bottom"} />
    </ToastProvider>
  );
}
